import { pick } from 'lodash-es'
import { $TSFixMe } from 'types/ts-migrate'

export const makeClasses = (propsArray: any) => {
  return propsArray
    .map((item: any, i: any) => {
      if (i === 0) {
        return item || ''
      }
      return item ? '-' + item : ''
    })
    .join('')
}

export const removeLoadingScreen = () => {
  // Don't cache loadingScreen (assign to variable) to prevent hot module reload errors
  if (document.getElementById('loadingScreen') !== null) {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    document.getElementById('loadingScreen').parentNode.removeChild(document.getElementById('loadingScreen'))
  }
}

export const filterObjectKeys = (keys: any, object: any) => {
  const filteredKeys = Object.keys(object).filter(p => keys.indexOf(p) < 0)
  return pick(object, filteredKeys)
}

export const getLastFourDigits = (number: string) => {
  return number.substring(number.length - 4, number.length)
}

export const rgbaToHex = rgba => {
  const rgbaMatch = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/)
  if (!rgbaMatch) return rgba

  const r = parseInt(rgbaMatch[1])
  const g = parseInt(rgbaMatch[2])
  const b = parseInt(rgbaMatch[3])
  const a = parseFloat(rgbaMatch[4] || 1)

  const componentToHex = c => {
    const hex = c.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }

  const alphaHex = Math.round(a * 255).toString(16)

  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`
}
